import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Solutions from "./pages/Solutions";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import InstallationCommissioning from "./pages/IC.jsx";
import Quote from "./pages/Quote";
import Footer from "./components/Footer";


export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-gradient-to-b from-white to-green-50 pb-80">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/i-c" element={<InstallationCommissioning />} />
          <Route path="/quote" element={<Quote />} />
        </Routes>

     <Footer />
      </div>
    </BrowserRouter>
  );
}
